import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';
import s from './PrivacyPages.css';
import Messages from './Messages';
import { 
  ILEXCONNECT_URL, 
  SPIROTECH_URL, 
  TEST_SPIROTECH_URL 
} from '../../constants/websites';

class GDPR extends React.Component {
  renderCommon = messages => {
    return (
      <div className={s.wrapper}>
        <ul className={s.test_ul}>
          <li>
            <FormattedMessage {...messages.husty_privacy_point_1} />
          </li>
          <li>
            <FormattedMessage {...messages.husty_privacy_point_2} />
          </li>
          <li>
            <FormattedMessage {...messages.husty_privacy_point_3} />
          </li>
          <li>
            <FormattedMessage {...messages.husty_privacy_point_4} />
          </li>
          <li>
            <FormattedMessage {...messages.husty_privacy_point_5} />
          </li>
          <li>
            <FormattedMessage {...messages.husty_privacy_point_6} />
          </li>
          <li>
            <FormattedMessage {...messages.husty_privacy_point_7} />
          </li>
          <li>
            <FormattedMessage {...messages.husty_privacy_point_1} />
          </li>
          <li>
            <FormattedMessage {...messages.husty_privacy_point_8} />
          </li>
          <ul className={s.test_ul}>
            <li className={s.list_characters}>
              <FormattedMessage {...messages.husty_privacy_point_8_a} />
            </li>
            <li className={s.list_characters}>
              <FormattedMessage {...messages.husty_privacy_point_8_b} />
            </li>
            <li className={s.list_characters}>
              <FormattedMessage {...messages.husty_privacy_point_8_c} />
            </li>
            <li className={s.list_characters}>
              <FormattedMessage {...messages.husty_privacy_point_8_d} />
            </li>
            <li className={s.list_characters}>
              <FormattedMessage {...messages.husty_privacy_point_8_f} />
            </li>
          </ul>
        </ul>
      </div>
    );
  };

  renderSpirotech = messages => {
    return (
      <div className={s.wrapperSpirotech}>
        <div>
          <p className={s.introduce}>
            <FormattedMessage {...messages.spirotech_privacy_introduce_part1} />
          </p>
          <p className={s.introduce}>
            <FormattedMessage {...messages.spirotech_privacy_introduce_part2} />
          </p>
          <p className={s.introduce}>
            <FormattedMessage {...messages.spirotech_privacy_introduce_part3} />
          </p>
          <p className={s.introduce}>
            <FormattedMessage {...messages.spirotech_privacy_introduce_part4} />
          </p>
        </div>
        <div>
          <p className={s.introduce}>
            <b>
              <FormattedMessage {...messages.spirotech_privacy_contact_part1} />
            </b>
          </p>
          <p className={s.introduce}>
            <FormattedMessage {...messages.spirotech_privacy_contact_part2} />
          </p>
          <p className={s.introduce}>
            <FormattedMessage {...messages.spirotech_privacy_contact_part3} />
          </p>
          <p className={s.introduce}>
            <FormattedMessage {...messages.spirotech_privacy_contact_part4} />
          </p>
        </div>

        <ul className={s.test_ul}>
          <li>
            <b>
              <FormattedMessage {...messages.spirotech_privacy_point_1_text} />
            </b>
          </li>
          <ul className={s.test_ul}>
            <li className={s.list_none}>
              <FormattedMessage {...messages.spirotech_privacy_point_1} />
            </li>
          </ul>
          <li>
            <b>
              <FormattedMessage {...messages.spirotech_privacy_point_2_text} />
            </b>
          </li>
          <ul className={s.test_ul}>
            <li className={s.list_none}>
              <FormattedMessage {...messages.spirotech_privacy_point_2} />
            </li>
          </ul>
          <li>
            <b>
              <FormattedMessage {...messages.spirotech_privacy_point_3_text} />
            </b>
          </li>
          <ul className={s.test_ul}>
            <li className={s.list_none}>
              <FormattedMessage {...messages.spirotech_privacy_point_3} />
            </li>
          </ul>
          <li>
            <b>
              <FormattedMessage {...messages.spirotech_privacy_point_4_text} />
            </b>
          </li>
          <ul className={s.test_ul}>
            <li className={s.list_none}>
              <FormattedMessage {...messages.spirotech_privacy_point_4} />
            </li>
          </ul>
          <li>
            <b>
              <FormattedMessage {...messages.spirotech_privacy_point_5_text} />
            </b>
          </li>
          <ul className={s.test_ul}>
            <li className={s.list_none}>
              <FormattedMessage {...messages.spirotech_privacy_point_5} />
            </li>
          </ul>
          <li>
            <b>
              <FormattedMessage {...messages.spirotech_privacy_point_6_text} />
            </b>
          </li>
          <ul className={s.test_ul}>
            <li className={s.list_none}>
              <FormattedMessage {...messages.spirotech_privacy_point_6} />
            </li>
          </ul>
        </ul>
      </div>
    );
  };

  render() {
    const messages = Messages();
    const { hostname } = this.props;
    // const hostname = TEST_SPIROTECH_URL;
    switch (hostname) {
      case ILEXCONNECT_URL:
        return this.renderCommon(messages);
      case SPIROTECH_URL:
      case TEST_SPIROTECH_URL:
        return this.renderSpirotech(messages);
      default:
        return this.renderCommon(messages);
    }
  }
}

GDPR.defaultProps = {
  hostname: '',
};

GDPR.propTypes = {
  hostname: PropTypes.string,
};

export default withStyles(s)(GDPR);



// WEBPACK FOOTER //
// ./src/components/PrivacyPages/GDPR.js